import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TRPCReactProvider } from "@/trpc/react";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/cookie-consent";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AuthProvider>
      <TRPCReactProvider>
        <Outlet />
        <Toaster />
        <CookieConsent />
      </TRPCReactProvider>
    </AuthProvider>
  );
}
